// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.

/**
 * Browsers throttle (or entirely pause) requestAnimationFrame in a hidden tab.
 * pdf.js schedules its page-render continuations on rAF, so an export that is
 * running while the user has switched to another tab can stall indefinitely.
 * This installs a hybrid: native rAF while the tab is visible (smooth), a
 * setTimeout fallback while it is hidden (keeps rendering making progress).
 */
if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
  const native = window.requestAnimationFrame.bind(window);
  window.requestAnimationFrame = (cb: FrameRequestCallback): number => {
    if (document.hidden) {
      return window.setTimeout(() => cb(performance.now()), 16) as unknown as number;
    }
    return native(cb);
  };
}
